import { tabelaVigente } from '@zenda/kernel/custo-de-mensagem';

const VIGENTE = tabelaVigente(new Date());

/**
 * ✅ Tabela oficial da Meta em BRL, mercado Brasil, "effective October 1, 2026"
 * (PDF "Cost per message in BRL", seção Rate cards and volume tiers de
 * developers.facebook.com/documentation/business-messaging/whatsapp/pricing).
 * Os valores vêm da tabela do `@zenda/kernel`, a mesma que custeia cada mensagem.
 *
 * ✅ Serviço (resposta dentro da janela de 24 h) é grátis até 01/10/2026 e passa a ser
 * cobrado por mensagem a partir dessa data (pricing/non-template-messages).
 */
export const PRECOS_META = {
  vigencia: '2026-10-01',
  moeda: 'BRL',
  servico: (VIGENTE.meta['service'] ?? 0) / 1_000_000,
  utilidade: (VIGENTE.meta['utility'] ?? 0) / 1_000_000,
  marketing: (VIGENTE.meta['marketing'] ?? 0) / 1_000_000,
  fonte: 'https://whatsappbusiness.com/pt-br/products/platform-pricing/',
} as const;

export function servicoJaCobrado(agora: Date = new Date()): boolean {
  return agora >= new Date(`${PRECOS_META.vigencia}T00:00:00-03:00`);
}

export function reais(valor: number): string {
  const casas = valor < 0.1 ? 3 : 2;
  return valor.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: casas,
    maximumFractionDigits: 4,
  });
}

/** O custo de uma mensagem: três casas, porque R$ 0,04 esconderia a diferença para R$ 0,035. */
export function reaisDeMicros(micros: number): string {
  return reais(micros / 1_000_000);
}

/** O extrato do parceiro, na moeda da carteira dele. */
export function valorDoExtrato(micros: number, moeda: string): string {
  const valor = micros / 1_000_000;
  const casas = valor > 0 && valor < 1 ? 3 : 2;
  return valor.toLocaleString('pt-BR', {
    style: 'currency',
    currency: moeda,
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

/** O total do mês: centavos bastam, salvo quando ainda não chegou a um real. */
export function reaisDoTotal(micros: number): string {
  const valor = micros / 1_000_000;
  const casas = valor > 0 && valor < 1 ? 3 : 2;
  return valor.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}
